import React, { useState } from 'react';
import { LeadFormDialog } from './LeadFormDialog';

export const StickyQuoteButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="sticky-quote-btn"
        data-testid="sticky-quote-btn"
      >
        Request Quote
      </button>

      <LeadFormDialog
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        sourcePage="sticky-button"
        leadType="quote_request"
        title="Request a Quote"
        subtitle="Fill in your details and we'll get back to you within 24 hours"
      />
    </>
  );
};

export default StickyQuoteButton;
